<template>
  <v-dialog
    v-model="dialogShow"
    persistent
    max-width="400"
  >
    <v-card class="error-dialog">
      <v-card-text class="error-dialog__content">
        <div class="error-dialog__title">
          Error
        </div>
        <div class="error-dialog__message">
          {{ message }}
        </div>
      </v-card-text>
      <v-card-actions class="error-dialog__actions">
        <v-btn
          color="var(--bg)"
          block
          @click="handleClose"
        >
          OK
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "ErrorDialog",

  computed: {
    ...mapState("app", ["errorDialog"]),

    dialogShow() {
      return this.errorDialog?.show || false;
    },

    message() {
      return this.errorDialog?.message || "";
    },
  },

  methods: {
    handleClose() {
      this.$store.dispatch("app/closeErrorDialog");
    },
  },
};
</script>

<style lang="scss" scoped>
.error-dialog {
  border-radius: 12px !important;

  &__content {
    padding: 24px 24px 16px !important;
    text-align: center;
  }

  &__title {
    font-size: 20px;
    font-weight: 600;
    color: var(--bg);
    margin-bottom: 16px;
  }

  &__message {
    font-size: 16px;
    color: #333;
    line-height: 1.5;
  }

  &__actions {
    padding: 8px 24px 24px !important;
  }
}
</style>

